import http from '../../../utils/fetch';
export default {
    showJD() {
        return http({
            url: '/api/swyl/v1/demo/loudType/showJD',
            method: 'post',
        });
    },
    // showType(q) {
    //     return http({
    //         url: '/api/swyl/v1/demo/loudType/showType',
    //         method: 'post',
    //         params: q,
    //     });
    // },
    showType:function(timeB, timeE){
        return http.post("/api/swyl/v1/demo/loudType/showType?timeB="+timeB+"&timeE="+timeE);
    },
}